export const FLASH_MESSAGE_SHOW = 'FLASH_MESSAGE_SHOW';
export const FLASH_MESSAGE_HIDE = 'FLASH_MESSAGE_HIDE';
export const BANNER_MESSAGE_SHOW = 'BANNER_MESSAGE_SHOW';
export const BANNER_MESSAGE_HIDE = 'BANNER_MESSAGE_HIDE';
